import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_ZIPCODE_INTERNACIONAL_" }
);

export interface FetchZipcodeInternacionalState extends IState {}

const INITIAL_STATE: FetchZipcodeInternacionalState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchZipcodeInternacionalState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchZipcodeInternacionalState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchZipcodeInternacionalState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchZipcodeInternacional = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchZipcodeInternacionalTypes = Types;
export const FetchZipcodeInternacionalActions = Creators;
